import BulkAdd from './bulk-add';
import PageHelper from '../../helpers/page-helper';
import { CartEntry } from '../../model/cart-entry';

export default class QuickOrder {

  private static CART_REDIRECT_URL = `${window.ACC.config.encodedContextPath}/cart`;

  private productList: CartEntry[] = [];
  private readonly bulkAdd: BulkAdd;
  private readonly resetButton: JQuery;
  private readonly maxRows: number;
  private readonly minRows: number;
  private readonly addToCartUrl: string;

  constructor(private container: JQuery) {
    const quickOrderContainer: JQuery = container.find('.js-quickOrderContainer');
    this.addToCartUrl = quickOrderContainer.data('quickOrderAddToCartUrl');
    this.maxRows = quickOrderContainer.data('quickOrderMaxRows') as number;
    this.minRows = quickOrderContainer.data('quickOrderMinRows') as number;
    this.resetButton = container.find('.js-resetQuickOrderButton');
    this.bulkAdd = new BulkAdd(container.find('.js-bulkAdd'));

    this.bindBulkAddButton();
    this.bindResetButton();
  }

  private handleAddToCartSuccess = (response: any, shouldRedirect: boolean) => {
    this.bulkAdd.showProductsAddedInfo();

    if (typeof window.ACC.minicart.updateMiniCartDisplay === 'function') {
      window.ACC.minicart.updateMiniCartDisplay();
    }

    PageHelper.clearLoadingIndicator();
    if (shouldRedirect) {
      window.location.href = QuickOrder.CART_REDIRECT_URL;
    }
  };

  private getJSONDataForAddToCart(): string {
    return JSON.stringify({ cartEntries: this.productList });
  }

  private addToCart(shouldRedirect: boolean): void {
    $.ajax({
      url: this.addToCartUrl,
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: this.getJSONDataForAddToCart(),
      async: true,
      success: (response) => {
        this.handleAddToCartSuccess(response, shouldRedirect);
      },
      error: (jqXHR, textStatus, errorThrown) => {
        // log the error to the console
        PageHelper.clearLoadingIndicator();
        console.error(`The following error occurred: ${textStatus}`, errorThrown);
      },
    });
  }

  private getNumberOfProducts(): number {
    return this.productList.length;
  }

  private quickImportProducts(): void {
    PageHelper.showLoadingIndicator();
    $.ajax({
      type: 'POST',
      url: 'quickOrder/import',
      data: {
        bulkAddProducts: this.bulkAdd.getValue(),
      },
      dataType: 'text',
      success: (result) => {
        const { productDatas, errorMsgs } = JSON.parse(result);

        this.productList = [];
        productDatas.forEach((resultData: any) => {
          const { code, roundingQuantity, requestedQuantity } = resultData;
          const qtyValue = requestedQuantity || roundingQuantity;

          this.productList.push({
            quantity: qtyValue,
            product: {
              code,
            },
          });
        });

        if (errorMsgs.length) {
          const bulkAddContent = errorMsgs.join('\n');
          this.bulkAdd.setValue(bulkAddContent);
        }

        if (this.productList.length) {
          const shouldRedirect = !errorMsgs.length;
          this.addToCart(shouldRedirect);
        } else {
          PageHelper.clearLoadingIndicator();
        }
      },
      error: (result) => {
        PageHelper.clearLoadingIndicator();
        console.error(result);
      },
    });
  }

  private bindResetButton(): void {
    this.resetButton.on('click', () => window.location.reload());
  }

  private bindBulkAddButton(): void {
    this.bulkAdd.getButton().on('click', (event) => {
      event.preventDefault();
      window.NotificationHelper.closeNotifications();
      if (this.getNumberOfProducts() + this.bulkAdd.getValueLineCount() <= this.maxRows && this.getNumberOfProducts() + this.bulkAdd.getValueLineCount() > 0) {
        this.quickImportProducts();
      } else {
        this.bulkAdd.showLengthError();
      }
    });
  }
}
